<div class="winstar-tooltip animated fadeIn show-tooltip ">
  <div class="winstar-tooltip-inner">
      <a href="javascript:void(0);" (click)="hideGamificationRule()" class="winstar-close-icon"><img src="assets/img/cross-icon-white.png" alt="{{bs.getResource('rbkey_GamfctnRlClsLBL')}}"></a>
      <div class="winstar-tooltip-top">
        {{bs.getResource('rbkey_gamificationChncTWnLBL')}}  
          <div class="points-label-img"><small>{{bs.getResource('rbkey_gamificationUptLBL')}}</small>{{gamificationPoints}} <small>{{bs.getResource('rbKey_Gmfctn_PntsLBL')}}</small></div>
      </div>
      <div class="winstar-tooltip-bottom">
          <div class="winstar-tooltip-bottom-heading">{{bs.getResource('rbkey_gamificationHwTErnLBL')}}</div>
          <ul *ngFor="let areaItem of gamificationAreaData" class="winstar-tooltip-bottom-list">
              <label>{{areaItem.AreaName}} </label>
                <li *ngFor="let ruleItem of areaItem['Rules']">{{ruleItem.RuleDescription}} : <b>{{ruleItem.RulePoints}}</b>
                </li>                
          </ul> 
      </div>
  </div>
</div>
